<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <proveedor-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ProveedorCrud from "./ProveedorCrud";
    export default {
        name: "ProveedorManagementPage",
        components: {ProveedorCrud}
    }
</script>

<style scoped>

</style>
